import { User } from '@/models/User'

export interface UserState {
    listUsers: Array<User>;
    authenticated: Boolean;
    errorStatus: string;
    sessionLog: Boolean,
    currentUser: any,
    usersLogged: any,
    nomDossier: string,
    keyDossier: string,
    envDossier: string,
    annonce : string

}
export enum USER_STORE {
    SET_LIST_USER = "SET_LIST_USER",
    SET_STATE_AUTH = "SET_STATE_AUTH",
    SET_STATE_ERROR = "SET_STATE_ERROR",
    SET_SESSION_LOG = "SET_SESSION_LOG",
    SET_CURRENT_USER = "SET_CURRENT_USER",
    SET_USERS_LOGGED = "SET_USERS_LOGGED",
    SET_NOM_DOSSIER = "SET_NOM_DOSSIER",
    SET_KEY_DOSSIER = "SET_KEY_DOSSIER",
    SET_ENV_DOSSIER = "SET_ENV_DOSSIER",
    SET_ANNONCE = "SET_ANNONCE",
    AUTH_INIT = "",
    AUTH_CHAMPS_VIDE = "Veuillez renseigner tous les champs puis reessayer",
    AUTH_INCORRECT = "Identifiants incorrects, Veuillez reessayer",
    AUTH_NO_ACTIVITES = "L'utilisateur n'a aucune activité !",
    AUTH_NO_ETABLISSEMENTS = "L'utilisateur n'a aucun établissements !",
    AUTH_AUTRES_USER = "Vos identifiants ne correspondent pas à la clé d'installation de cet appareil. Veuillez réessayer"

}